import { render, staticRenderFns } from "./HelpdeskNotificactionDropdown .vue?vue&type=template&id=786563b0&scoped=true"
import script from "./HelpdeskNotificactionDropdown .vue?vue&type=script&lang=js"
export * from "./HelpdeskNotificactionDropdown .vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786563b0",
  null
  
)

export default component.exports